import { render, staticRenderFns } from "./RenewEn.vue?vue&type=template&id=00d0602f&scoped=true&"
var script = {}
import style0 from "./RenewEn.vue?vue&type=style&index=0&id=00d0602f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0602f",
  null
  
)

export default component.exports